import './LeadDetailsDrawer.css';
import { useEffect, useState } from 'react';
import Close from '../../../assets/icons/trvto_close.svg';
import Instagram from '../../../assets/icons/trvto_instagram.svg';
import Copy from '../../../assets/icons/trvto_copy.svg';
import Whatsapp from '../../../assets/icons/trvto_whatsapp.svg';
import Location from '../../../assets/icons/trvto_location.svg';
import {
    supChatBotaddCommentFun,
    supChatbotMessages,
    supChatBotSendMessage,
    supChatbotUserUpdate
} from '../../../api/supportAdmin';
import { toast } from 'react-toastify';
import axios from 'axios';
import { formatPhone } from '../../../utils/formatPhoneNumber';
import { getChatTimeLeft } from '../../../utils/getChatTimeLeft';
import ChatScreen from '../ChatScreen';
import Header from './Header';
import Summary from './Summary';
import DetailsTab from './DetailsTab';
import CommentsTab from './CommentsTab';
import MessagesTab from './MessagesTab';
import CallsTab from './CallsTab';
import WebsiteTab from './WebsiteTab';
import { assignChatUser, getAssignableSupUsers, getAssignHistory } from '../../../api/superAdmin';
import AssignedDetails from './AssignedDetails';

export default function LeadDetailsDrawer({ open, onClose, user, setSelectedUser }) {
    const [leadStatus, setLeadStatus] = useState('');

    const [activeTab, setActiveTab] = useState('details');

    const [messages, setMessages] = useState([]);
    const isSuperAdmin = localStorage.getItem('supAccess') === 'superAdmin';
    const [assignmentHistory, setAssignmentHistory] = useState([]);
    const [supportUsers, setSupportUsers] = useState([]);
    const [assignmentLoading, setAssignmentLoading] = useState(false);

    useEffect(() => {
        if (!open || !user?._id || !isSuperAdmin) return;

        fetchAssignmentHistory();
    }, [open, user?._id, isSuperAdmin]);

    useEffect(() => {
        if (!open || !isSuperAdmin) return;

        fetchAssignableUsers();
    }, [open, isSuperAdmin]);

    const fetchAssignableUsers = async () => {
        try {
            const result = await getAssignableSupUsers();

            if (result.status === 200) {
                setSupportUsers(result.data.data || []);
            }
        } catch (error) {
            console.error('Error fetching assignable users:', error);
        }
    };

    const fetchAssignmentHistory = async () => {
        try {
            const result = await getAssignHistory(user._id);

            if (result.status === 200) {
                setAssignmentHistory(result.data.data || []);
            }
        } catch (error) {
            console.error('Error fetching assignment history:', error);
        }
    };

    const assignUser = async (supportUserId) => {
        try {
            setAssignmentLoading(true);

            const result = await assignChatUser(user._id, supportUserId);

            if (result.status === 200) {
                toast.success(result.data.message);

                // Update lead data in parent
                setSelectedUser((prev) => ({
                    ...prev,
                    assignedSupportId: result.data.data.assignedUser,
                    assignedAt: result.data.data.assignedAt,
                    assignmentType: result.data.data.assignmentType
                }));

                // Refresh history
                await fetchAssignmentHistory();
            }
        } catch (error) {
            console.error('Assignment error:', error);

            toast.error(error?.response?.data?.message || 'Failed to assign user');
        } finally {
            setAssignmentLoading(false);
        }
    };

    const sendMessage = async (message) => {
        if (!message.trim()) {
            toast.error('Enter a message');

            return;
        }
        try {
            const result = await supChatBotSendMessage({
                userId: user._id,
                message: message
            });
            if (result.status === 200) {
                toast.success(result.data.message);
            }
        } catch (error) {
            console.log(error);
        }

        // Call your API here
    };

    const getStatus = (user) => {
        if (user?.selectedPlace) return 'Place Selected';
        if (user?.selectedType) return 'Type Selected';
        if (user?.selectedCity) return 'City Selected';
        return 'Started';
    };

    const getFollowUps = (user) => {
        return [
            user?.followUp1Sent,
            user?.followUp2Sent,
            user?.followUp3Sent,
            user?.followUp4Sent,
            user?.followUp5Sent
        ].filter(Boolean).length;
    };

    const comments = user.comments.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    if (!open) return null;

    // const submitComment = async () => {
    //     if (!comment.trim()) return;

    //     try {
    //         const res = await supChatBotaddCommentFun({
    //             id: user._id,
    //             message: comment,
    //             status: leadStatus
    //         });

    //         if (res.status === 200) {
    //             setSelectedUser(res.data.response);
    //             toast.success(res.data.message);
    //             setComment('');
    //         }
    //     } catch (err) {
    //         console.error(err);
    //     }
    // };

    const updateUserData = async (data) => {
        if (data?.comment && !data?.updates?.leadStatus) {
            if (!data.comment.trim()) {
                toast.warning('Enter the comment');
                return;
            }
        }
        try {
            const result = await supChatbotUserUpdate(user._id, data);
            console.log(result.data.response, 'api data');
            setSelectedUser((prev) => ({
                ...prev,
                ...result.data.response
            }));
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <>
            <div className='drawer-backdrop' onClick={onClose} />

            <div className='leadDrawer'>
                <button className='drawerClose' onClick={onClose}>
                    <img src={Close} width={22} alt='' />
                </button>

                {/* HEADER */}

                <Header
                    user={user}
                    getStatus={getStatus}
                    supportUsers={supportUsers}
                    assigning={assignmentLoading}
                    onAssign={assignUser}
                    isSuperAdmin={isSuperAdmin}
                />

                {/* SUMMARY */}

                <Summary
                    user={user}
                    getFollowUps={getFollowUps}
                    setSelectedUser={setSelectedUser}
                    updateUserData={updateUserData}
                />

                {/* TABS */}

                <div className='drawerTabs'>
                    <button
                        className={`drawerTab ${activeTab === 'details' ? 'active' : ''}`}
                        onClick={() => setActiveTab('details')}
                    >
                        Details
                    </button>
                    {isSuperAdmin && (
                        <button
                            className={`drawerTab ${activeTab === 'assigned' ? 'active' : ''}`}
                            onClick={() => setActiveTab('assigned')}
                        >
                            Assigned Details
                        </button>
                    )}

                    <button
                        className={`drawerTab ${activeTab === 'website' ? 'active' : ''}`}
                        onClick={() => setActiveTab('website')}
                    >
                        Website{typeof user?.leadScore === 'number' ? ` · ${user.leadScore}` : ''}
                    </button>

                    <button
                        className={`drawerTab ${activeTab === 'calls' ? 'active' : ''}`}
                        onClick={() => setActiveTab('calls')}
                    >
                        Calls
                    </button>

                    <button
                        className={`drawerTab ${activeTab === 'comments' ? 'active' : ''}`}
                        onClick={() => setActiveTab('comments')}
                    >
                        Comments
                    </button>

                    <button
                        className={`drawerTab ${activeTab === 'messages' ? 'active' : ''}`}
                        onClick={() => setActiveTab('messages')}
                    >
                        Messages
                    </button>

                    <button
                        className={`drawerTab ${activeTab === 'chats' ? 'active' : ''}`}
                        onClick={() => setActiveTab('chats')}
                    >
                        <div className='platform-icon'>
                            <p>Chats</p>

                            {user?.unreadCount > 0 && <span className='badge-chat'>{user.unreadCount}</span>}
                        </div>
                    </button>
                </div>

                <div className='tabContent'>
                    {activeTab === 'details' && (
                        <DetailsTab
                            user={user}
                            getStatus={getStatus}
                            getFollowUps={getFollowUps}
                            setSelectedUser={setSelectedUser}
                            updateUserData={updateUserData}
                        />
                    )}

                    {activeTab === 'assigned' && (
                        <AssignedDetails
                            user={user}
                            assignmentHistory={assignmentHistory}
                            supportUsers={supportUsers}
                            isSuperAdmin={isSuperAdmin}
                            assigning={assignmentLoading}
                            onAssign={assignUser}
                        />
                    )}

                    {activeTab === 'website' && <WebsiteTab user={user} />}

                    {activeTab === 'calls' && <CallsTab user={user} />}

                    {activeTab === 'comments' && <CommentsTab user={user} updateUserData={updateUserData} />}

                    {activeTab === 'messages' && (
                        <MessagesTab user={user} sendMessage={sendMessage} messages={messages} />
                    )}

                    {activeTab === 'chats' && (
                        <ChatScreen
                            chatId={user._id}
                            sendMessage={sendMessage}
                            updateUserData={updateUserData}
                            user={user}
                        />
                    )}
                </div>
            </div>
        </>
    );
}
